module.exports = __webpack_public_path__ + "img/kids.a6d1efd2.svg";